var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgEditBluePencil = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.10312 8.98832L3.5293 11.4141L10.2357 4.70888L7.80949 2.28313L1.10312 8.98832Z",
    fill: "#5D5CF5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.798 2.01039L10.509 0.721732C10.195 0.407723 9.66366 0.4299 9.32221 0.771282L8.11133 1.98197L10.5375 4.4077L11.7484 3.19703C12.0898 2.85565 12.112 2.32437 11.798 2.01039Z",
    fill: "#5D5CF5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.877306 9.375L0.20534 11.8246C0.123324 12.1235 0.397901 12.3981 0.696884 12.3161L3.14667 11.6443L0.877306 9.375Z",
    fill: "#5D5CF5"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEditBluePencil, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/edit-blue-pencil.ec3395ea.svg";
export { ForwardRef as ReactComponent };